import session from './session';

export default {
    login(email, password) {
        return session.post('user/login/', { email, password });
    },
    sendOTP(email) {
        return session.post('user/send_otp/', { email });
    },
    changeAccountPassword(password, password1, password2) {
        return session.post('user/change-password/', { password, password1, password2 });
    },
};
